import UserDataService from 'common/services/userData.service.js';

class SolidarityUserDataService extends UserDataService{
  constructor() {
    super();
  }

}

export default SolidarityUserDataService;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/services/solidarityUserData.service.js